export const transitions = {
  in2in: 0.3,
  out2in: 0.15,
  in2out: 0.25,
  actionable: 0.07,
};
